export enum appPhase {
    "HOME" = "home",
    "AVAILABILITY" = "availability",
    "PROFILE" = "profile",
    "CONFIRMATION" = "confirmation",
    "FIND-RESERVATION" = "find-reservation",
}

export enum reservationStatus {
    "ACTIVE" = "active",
    "TEMPORARY" = "temporary",
    "CONFIRMED" = "confirmed",
    "CANCELLED" = "CANCELLED"
}

export enum mandatoryDepositType {
    "PERCENTAGE_FROM_TOTAL" = "PERCENTAGE_FROM_TOTAL",
    "PERCENTAGE_FROM_ROOMRATE" = "PERCENTAGE_FROM_ROOMRATE", 
    "FIXED" = "FIXED",
    "PAYMENT_AT_ARRIVAL" = "PAYMENT_AT_ARRIVAL"
}

export enum paymentError {
    "CANCELLED" = 1,
    "FAILED" = 2
}

export enum pimSoftware {
    "BOOKINGENGINE" = 6,
    "GIFTCARD" = 8
}

export enum externalLoginProvider {
    "SFC" = "sfc",
    "IDACTOR" = "idactor"
}